import React from 'react'

const PageNotFound = () => {
    return (
        <div style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            padding: "10px"
        }}>
            <h1>404 | Page Not Found</h1>
        </div>
    )
}

export default PageNotFound
